module.exports = __webpack_public_path__ + "static/biz-ng-3fa7be13e6820be9947613cdd2495b27.jpg";